import store from "src/Reducers/store";
import * as appActions from "src/Actions/appActions";

const setPreviousPage = (pageIndex: string) => store.dispatch(appActions.setPreviousPage(pageIndex));

export default setPreviousPage;
